import React, { useMemo } from 'react';
import { View } from 'react-native';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import { Page, Text } from '../uiold';
import { useFetchJson } from '../../support/useFetch';

import FormEditor from './FormEditor';

import { Market } from '../../types/shared/Market';
import { FormSubmissions } from '../../types/shared/FormSubmission';

function EditPage() {
  const fetchJson = useFetchJson();

  const { data: markets } = useQuery(['markets'], () => {
    return fetchJson(
      `/api/markets`,
      null,
      (data) => data.markets as Array<Market>,
    );
  });

  const {
    data: dataSubmissions,
    // TODO: Rename revalidateSubmissions
    refetch: revalidateSubmissions,
  } = useQuery(['forms/evaluation/submissions'], () => {
    return fetchJson<FormSubmissions>('/api/forms/evaluation/submissions');
  });

  let activeMarkets = useMemo(
    () => (markets ? markets.filter((m) => !!m.dates.length) : []),
    [markets],
  );

  if (markets == null || dataSubmissions == null) {
    return <Page isLoading={true} />;
  }

  let { submissions } = dataSubmissions;

  if (activeMarkets.length === 0) {
    return (
      <Page>
        <Page.Header title={t('Market Reports')} />
        <View style={{ flex: 1 }}>
          <Text type="label">
            {t.jsx(
              "You don't have any market dates.<link>Click Here</link> to edit your market dates.",
              {
                link: (content) => <Link to="/markets">{content}</Link>,
              },
            )}
          </Text>
        </View>
      </Page>
    );
  }

  return (
    <Page>
      <Page.Header title={t('Market Reports')} />
      <FormEditor
        markets={markets}
        submissions={submissions}
        revalidateSubmissions={revalidateSubmissions}
      />
    </Page>
  );
}

export default EditPage;
